import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// tailwind-merge only knows Tailwind's stock font sizes, and takes any other
// `text-*` class for a text colour. `tiny` (tailwind.config.js) therefore has to
// be declared a font size here, or `text-tiny` is silently dropped whenever a
// colour class follows it.
const twMerge = extendTailwindMerge({
  extend: { classGroups: { 'font-size': [{ text: ['tiny'] }] } },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
